import {
  FETCH_USER_AI_MEMORY,
  FETCH_USER_AI_MEMORY_SUCCESS,
  FETCH_USER_AI_MEMORY_FAILED,
  FETCH_ALL_AI_MEMORY,
  FETCH_ALL_AI_MEMORY_SUCCESS,
  FETCH_ALL_AI_MEMORY_FAILED,
} from '../store/types';
import { firebase } from '../config/configureFirebase';
import { onValue, update, set, ref as dbRef } from 'firebase/database';
import { getDatabase } from 'firebase/database';

export const fetchUserAiMemory = (uid) => (dispatch) => {
  const { userAiMemoryRef } = firebase;
  dispatch({ type: FETCH_USER_AI_MEMORY });
  onValue(
    userAiMemoryRef(uid),
    (snap) => {
      dispatch({
        type: FETCH_USER_AI_MEMORY_SUCCESS,
        payload: { uid, memory: snap.val() || null },
      });
    },
    (err) => {
      dispatch({ type: FETCH_USER_AI_MEMORY_FAILED, payload: err.message });
    },
  );
};

export const saveUserAiMemoryData = (uid, data) => async () => {
  const { userAiMemoryRef } = firebase;
  await update(userAiMemoryRef(uid), { ...data, updatedAt: Date.now() });
};

export const saveUserCityRec = (uid, cityKey, data) => async () => {
  const db = getDatabase();
  await set(dbRef(db, `user_ai_memory/${uid}/city_recs/${cityKey}`), data);
};

export const fetchAllAiMemory = () => (dispatch) => {
  const { allUserAiMemoryRef } = firebase;
  dispatch({ type: FETCH_ALL_AI_MEMORY });
  onValue(
    allUserAiMemoryRef,
    (snap) => {
      dispatch({ type: FETCH_ALL_AI_MEMORY_SUCCESS, payload: snap.val() || {} });
    },
    (err) => {
      dispatch({ type: FETCH_ALL_AI_MEMORY_FAILED, payload: err.message });
    },
  );
};
